import { configureStore } from '@reduxjs/toolkit';
import adminUserSlice from './slices/adminUsersSlice/adminUserSlice';
import dashboardManagementSlice from './slices/dashboardManagementSlice/dashboardManagementSlice';
import faqManagementReducer from './slices/faqsManagementSlice/faqSlice';
import metaDataReducer from './slices/metaDataSlice/metaDataSlice';
import notificationManagementReducer from './slices/notificationManagementSlice/notificationManagementSlice';
import projectsReducer from './slices/projectsSlice/projectsSlice';
import projectUsersReducer from './slices/projectUsersSlice/projectUsersSlice';
import rolesPermissionsReducer from './slices/rolesPermissionsSlice/rolesPermissionsSlice';
import siteReducer from './slices/siteManagementSlice/siteManagementSlice';
import surveyManagementReducer from './slices/surveyManagementSlice/surveyManagementSlice';
import surveySetManagementReducer from './slices/surveySetManagementSlice/surveySetManagementSlice';
import walletSlice from './slices/walletManagementSlice/walletSlice';
import projectSystemUserSlice from './slices/adminUsersSlice/projectSystemUserSlice';
import currencyReducer from './slices/currencySlice/currencySlice';

export const store = configureStore({
  reducer: {
    rolesPermissions: rolesPermissionsReducer,
    survey: surveyManagementReducer,
    surveySet: surveySetManagementReducer,
    projects: projectsReducer,
    projectUsers: projectUsersReducer,
    notification: notificationManagementReducer,
    sites: siteReducer,
    metaData: metaDataReducer,
    faq: faqManagementReducer,
    wallet: walletSlice,
    user: adminUserSlice,
    systemProjectUsers: projectSystemUserSlice,
    dashboard: dashboardManagementSlice,
    currency: currencyReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
